import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { SubscriptionInfo } from '@client/utils/shared-constants';
import { EMPTY, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class SubscriptionService {
	constructor(private afAuth: AngularFireAuth, private db: AngularFireDatabase) {}

	hydrate(): Observable<SubscriptionInfo> {
		return this.afAuth.user.pipe(
			switchMap(u => (u ? this.db.object<SubscriptionInfo>(`/user/${u.uid}/subscription`).valueChanges() : EMPTY))
		);
	}
}
